import { entrypointModule } from "@/utils/pages";

import { components } from "@/frontend/base/state";
import { onCartLoaded } from "@frontend/cart";
import { CustomElement } from "@frontend/component_set";

import { defineSvelteComponent } from "@/components/backports/svelte";


import "./environment";
import "./spinner";


function ensureCartLoaded(cb: () => Promise<{default: CustomElement}>): () => Promise<{default: CustomElement}> {
    return async () => {
        const elem = (await cb()).default;
        await new Promise<void>(rs => onCartLoaded(rs));
        return {default: {
            apply(element: HTMLUnknownElement) {
                return elem.apply(element);
            }
        }}
    }
}

components.set("tmws-event-selector", ensureCartLoaded(defineSvelteComponent(() => import("./UnseatedEventSelector.svelte"))));
components.set("tmws-multi-event-selector", ensureCartLoaded(defineSvelteComponent(() => import("./UnseatedMultiEvent.svelte"))));
components.set("tmws-event-total", ensureCartLoaded(defineSvelteComponent(() => import("./UnseatedEventSum.svelte"))));
components.set("tmws-event-ticket-form", ensureCartLoaded(defineSvelteComponent(() => import("./UnseatedTicketForm.svelte"))));
components.set("tmws-event-sell", ensureCartLoaded(defineSvelteComponent(() => import("./UnseatedEventSell.svelte"))));
components.set("tmws-gift-card-selector", ensureCartLoaded(defineSvelteComponent(() => import("./GiftCardSelector.svelte"))));
components.set("tmws-header-cart", ensureCartLoaded(defineSvelteComponent(() => import("./HeaderCart.svelte"))));
components.set("tmws-header-timer", ensureCartLoaded(defineSvelteComponent(() => import("./HeaderTimer.svelte"))));
components.set("tmws-viewport", ensureCartLoaded(defineSvelteComponent(() => import("./SeatedEventSelector.svelte"))));
components.set("tmws-chart-buttons", ensureCartLoaded(defineSvelteComponent(() => import("./SeatedButtons.svelte"))));
components.set("tmws-seatselect", ensureCartLoaded(defineSvelteComponent(() => import("./SeatedSelector.svelte"))));
components.set("tmws-infinite-scroll", ensureCartLoaded(defineSvelteComponent(() => import("./InfiniteScroll.svelte"))));
components.set("tmws-google-maps", ensureCartLoaded(defineSvelteComponent(() => import("./GoogleMaps.svelte"))));
components.set("tmws-bundle-entry", ensureCartLoaded(defineSvelteComponent(() => import("./BundleEntry.svelte"))));

entrypointModule("_v2/checkout", () => import("./checkout"));
entrypointModule("_v2/retry", () => import("./retry"));
entrypointModule("_v2/embed_payment", () => import("@/cart/checkout/payment"));
entrypointModule("_v2/calendar", () => import("./calendar"));
entrypointModule("_v2/event-socials", () => import("./event-socials"));
entrypointModule("_v2/giftcards", () => import("./giftcards"));

import "./turbo";
